import React from "react";

function InformationBarWarnStrong({
  message,
  rightText,
  showClose,
  fixed,
  rounded = true,
}: {
  message: string;
  rightText?: string;
  showClose?: boolean;
  fixed?: boolean;
  rounded?: boolean;
}) {
  showClose = showClose ?? true;
  fixed = fixed ?? true;
  return (
    <div
      role="alert"
      className="weui-information-bar weui-information-bar_warn-strong"
      style={{
        position: fixed ? "fixed" : "static",
        borderRadius: rounded ? "8px" : "0",
      }}
    >
      <div className="weui-information-bar__hd">
        <i className="weui-icon-outlined-warn"></i>
      </div>
      <div className="weui-information-bar__bd">{message}</div>
      <div className="weui-information-bar__ft">
        <a className="weui-link" href="#">
          {rightText}
        </a>
        {showClose && (
          <button className="weui-btn_icon">
            关闭<i className="weui-icon-close-thin"></i>
          </button>
        )}
      </div>
    </div>
  );
}

export { InformationBarWarnStrong };
